import React, { useLayoutEffect, useRef, useState } from "react";

import "./ReasonColumn.css";

// Lines shown before "See more" appears. Truncation is driven by the actual
// rendered width (CSS line clamp), so a wider column shows more text and only
// reasons that really overflow get the toggle.
const COLLAPSED_LINES = 2;

const collapsedStyle = {
  display: "-webkit-box",
  WebkitLineClamp: COLLAPSED_LINES,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  paddingLeft: 0,
};

// `compact` is for a note shown under other text (e.g. the admin's note in the
// Reviewed By cell): a step smaller, softer and italic, like a margin note, so it doesn't compete with the line above.
const compactTextStyle = { fontSize: "11px", lineHeight: 1.4, color: "#555", fontStyle: "italic" };

const ReasonColumn = (props) => {
  const reason = props.params.row?.reason;
  const { compact = false } = props;
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);
  const textRef = useRef(null);

  // Measure only while collapsed — once expanded the text is unclamped, so
  // keep the last collapsed result to decide whether "See less" is offered.
  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el || expanded) return undefined;

    const measure = () => setOverflowing(el.scrollHeight > el.clientHeight + 1);
    measure();

    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [reason, expanded]);

  return (
    <div style={{ padding: "5px 0px" }}>
      <span
        ref={textRef}
        className="table-cell-trucate-reason"
        style={{ ...(expanded ? { paddingLeft: 0 } : collapsedStyle), ...(compact ? compactTextStyle : {}) }}
      >
        {reason}
      </span>
      {(overflowing || expanded) && (
        <span
          className="table-cell-trucate-expand"
          style={{ display: "block", paddingLeft: 0, ...(compact ? { fontSize: "11px" } : {}) }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? "See less" : "See more"}
        </span>
      )}
    </div>
  );
};

export default ReasonColumn;
